var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(pool){return _c('div',{key:pool.name},[_c('b',[_vm._v(_vm._s(pool.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(pool.amount)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }